export const get = async (culture: string) => {
    let translations: Record<string, string>;
    try {
        translations = await import(
            `./translations-${culture || "en-gb"}.json`
        );
    } catch {
        translations = (await import(
            "./translations-en-gb.json"
        )) as unknown as Record<string, string>;
    }
    return translations;
};
export default { get };
